import { AbstractReport } from '../abstract-report.model';
import { AccessorsMutatorsDecorator } from '../../../../helpers/model';

export class ChannelProduction extends AbstractReport {

}

AccessorsMutatorsDecorator(
    'name',
    'total',
    'nights',
)(ChannelProduction);



// WEBPACK FOOTER //
// ./src/pms-api/models/reports/production/channel-production.model.js